function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "disabled-a",
  points: "0 0 17.913 0 17.913 17.829 0 17.829"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EDEDED",
  d: "M15,0 L15,0 C23.2842712,-1.52179594e-15 30,6.71572875 30,15 L30,15 C30,23.2842712 23.2842712,30 15,30 L15,30 C6.71572875,30 1.01453063e-15,23.2842712 0,15 L0,15 C-1.01453063e-15,6.71572875 6.71572875,1.52179594e-15 15,0 Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6 6)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "disabled-b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#disabled-a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M3.93297,14.8076852 L2.49177,15.3704066 L3.06897,13.9180131 L14.85897,2.14601311 L15.74847,3.03273443 L3.93297,14.8076852 Z M15.49917,0.263390164 C15.32997,0.0948983607 15.09927,-0.000118032787 14.85837,-0.000118032787 C14.61717,0.00017704918 14.38647,0.0951934426 14.21727,0.263980328 L1.65687,12.8049639 C1.57107,12.8905377 1.50417,12.992341 1.45977,13.104177 L0.06177,16.621259 C-0.06873,16.9496852 0.01137,17.3226689 0.26517,17.5711279 C0.43707,17.7396197 0.66657,17.8287344 0.90027,17.8287344 C1.01187,17.8287344 1.12437,17.8086689 1.23207,17.7664721 L4.77267,16.3851934 C4.88847,16.3394557 4.99377,16.2712918 5.08137,16.1839475 L17.65347,3.65476721 C17.99937,3.31011148 17.99937,2.75594754 17.65347,2.4112918 L15.49917,0.263390164 Z",
  mask: "url(#disabled-b)"
})));

function SvgIconEditPencilDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditPencilDisabled);
export default __webpack_public_path__ + "static/media/icon_edit_pencil_disabled.7eab331f.svg";
export { ForwardRef as ReactComponent };